<div class="flex flex-col justify-center gap-4">
  <div class="border-1 flex w-full flex-col justify-start gap-3 rounded-2xl border border-neutral-5 p-5 xs:gap-4 sm:gap-6 lg:gap-8">
    <div class="relative flex flex-col">
      <div class="my-2 inline-block font-heading text-sm font-medium text-neutral-100 xs:text-base">
        {{ 'lost-2fa.header.make-contact' | translate }}
      </div>
      <span class="text-sm">{{ 'lost-2fa.contact-info' | translate }}</span>
    </div>
    <div class="-m-5 border-b border-neutral-5"></div>
    <div class="flex flex-col">
      <div class="my-2 inline-block font-heading text-sm font-medium text-neutral-100 xs:text-base">
        {{ 'lost-2fa.header.our-number' | translate }}
      </div>
      <a href="tel:310-8888-666-66" class="text-md font-semibold text-primary underline">Tel: +31 (0) 8888 666 66</a>
    </div>
    <div>
      <div class="my-2 inline-block font-heading text-sm font-medium text-neutral-100 xs:text-base">
        {{ 'lost-2fa.header.your-code' | translate }}
      </div>
      <div class="flex justify-center rounded-md border-2 border-neutral-5 py-5 text-2xl">
        {{ code }}
      </div>
    </div>
    <div>
      <div class="my-2 inline-block font-heading text-sm font-medium text-neutral-100 xs:text-base">
        {{ 'lost-2fa.header.verification' | translate }}
      </div>
      <ul class="list-inside list-disc pl-3">
        <li>{{ 'lost-2fa.document-types.id-card' | translate }}</li>
        <li>{{ 'lost-2fa.document-types.driving-license' | translate }}</li>
        <li>{{ 'lost-2fa.document-types.residence-permit' | translate }}</li>
      </ul>
    </div>
  </div>
  <div class="flex gap-3 self-center">
    <span class="text-center text-neutral-80">
      <span class="text-primary-100 underline hover:cursor-pointer hover:text-primary-130" (click)="returnToLogin()">
        {{ 'reset-password.back-login.label' | translate }}
      </span>
    </span>
  </div>
</div>
